<template>
  <div>
    <div
      class="mapa"
      ref="mapa"
    ></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>

<script>
  import GoogleMapsApiLoader from "google-maps-api-loader";

  export default {
    props: {
      configMapa: Object,
      
      apiKey: String
    },
    data() {
      return {
        google: null,
        map: null
      };
    },
    async mounted() {
      const googleMapApi = await GoogleMapsApiLoader({
        libraries:['places'],
        apiKey: this.apiKey
      });
      this.google = googleMapApi;     
      this.initializeMap();
    },
    methods: {
      mAddNewLocation(newPos){
        console.log('llegando a la nueva posicion')
        console.log(newPos)
        
      },
      initializeMap() {
        const mapContainer = this.$refs.mapa;
        this.map = new this.google.maps.Map(mapContainer, this.configMapa);
      },
      addMapListeners(){
        this.map.addListener('dbclick', this.mClickNewMarker);
      },

      mClickNewMarker(){
        console.log('anadiendo la posicion del mapa')  
      }
    }
  };
</script>

<style scoped>
  .mapa {
    width: 100%;
    height: 600px;
  }
</style>


// WEBPACK FOOTER //
// src/components/maps/LoadMap.vue